import { ContentPluginRootState } from 'editor/src/component/DesktopSidebar/TabContents/Plugins/ContentProviderPlugin/store/types';

const getSearchValue = (state: ContentPluginRootState) => state.data.results?.search.value;

export default getSearchValue;
